module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-table-row-condition-request"
    }
  }, [_c('label', {
    staticClass: "color-skin align-center"
  }, [_vm._v("Status Approve Condition")]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.columns[_vm.nowLang].index,
      "data": _vm.index,
      "maxRowspan": _vm.maxRowspan,
      "indexDisp": true,
      "requestDisp": true,
      "addEvent": _vm.addEvent,
      "editEvent": _vm.editEvent,
      "cancelEvent": _vm.cancelEvent,
      "requestCancelDisp": false,
      "nowLang": _vm.nowLang
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "color-skin align-center"
  }, [_vm._v("Status Approve + Custom Condition")]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.columns[_vm.nowLang].index,
      "data": _vm.index,
      "maxRowspan": _vm.maxRowspan,
      "indexDisp": true,
      "requestDisp": true,
      "addEvent": _vm.addEvent,
      "editEvent": _vm.editEvent,
      "cancelEvent": _vm.cancelEvent,
      "requestCancelDisp": false,
      "nowLang": _vm.nowLang,
      "rowDisableCondition": _vm.rowDisableCondition
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a9cb8f70!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoTableRowConditionRequest.vue
// module id = 3952
// module chunks = 1